var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Date Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Date Icon - Green",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51",
    d: "M67.77 32.808H7a1.5 1.5 0 010-3h60.77a1.5 1.5 0 010 3z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32926",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M0 6.604h60.77a1.5 1.5 0 011.5 1.5v52.667a1.5 1.5 0 01-1.5 1.5H0a1.5 1.5 0 01-1.5-1.5V8.104a1.5 1.5 0 011.5-1.5zm59.27 3H1.5v49.667h57.77z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M16.205 15.68a1.5 1.5 0 01-1.5-1.5V0a1.5 1.5 0 113 0v14.18a1.5 1.5 0 01-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M44.564 15.68a1.5 1.5 0 01-1.5-1.5V0a1.5 1.5 0 113 0v14.18a1.5 1.5 0 01-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 56",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(14 33)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(28 33)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 61",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(42 33)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 57",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(14 47)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(28 47)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 60",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(42 47)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Date Icon - Green"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25865",
    fill: "none",
    d: "M0 0h74v74H0z"
  })))));
}

export default __webpack_public_path__ + "f05bc93ad08ab60806d81ecfe33ec4c5.svg";
export { SvgDateIcon as ReactComponent };